/**
 * Clusters whose payment agreement asks for E-SIGN consent (step 1 of the
 * signature wizard) before the customer signs (step 2). On the QA portal every
 * cluster gets it; elsewhere every other cluster keeps the single-step
 * signature wizard.
 */
export const ESIGN_CONSENT_CLUSTER_IDS: ReadonlySet<string> = new Set([
  "10432",
]);

/**
 * True on the QA portal (master deploys to payv2-qa.dcdial.com). Decided by
 * the hostname rather than an env variable, so a production build can never
 * match by mistake. Localhost counts as production.
 */
export const isQaPortalHost = (
  hostname: string = typeof window !== "undefined"
    ? window.location.hostname
    : ""
): boolean => hostname.trim().toLowerCase().endsWith("-qa.dcdial.com");

export const isEsignConsentEnabledForCluster = (
  clusterId: string | number | null | undefined,
  hostname?: string
): boolean =>
  isQaPortalHost(hostname) ||
  (clusterId !== null &&
    clusterId !== undefined &&
    ESIGN_CONSENT_CLUSTER_IDS.has(String(clusterId).trim()));
